import React, { useEffect, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import Chip from '@mui/material/Chip';
import axios from 'axios';

const columns = [
  { field: 'address', headerName: 'Address', flex: 1.5, minWidth: 200 },
  {
    field: 'status',
    headerName: 'Status',
    flex: 0.5,
    minWidth: 80,
    renderCell: (params) => {
        const value = params.value?.toLowerCase();

        const color =
        value === 'active' || value === 'actv' ? 'primary' :
        value === 'pending' || value === 'pend' ? 'warning' :
        value === 'hot' ? 'error' :
        value === 'sold' ? 'success' :
        'default';

        return <Chip label={params.value} color={color} size="small" />;
    },
  },
  {
    field: 'price',
    headerName: 'Price $',
    type: 'number',
    flex: 1,
    minWidth: 100,
  },
  {
    field: 'daysOnMarket',
    headerName: 'List Date',
    flex: 1,
    minWidth: 100,
    align: 'right',
    headerAlign: 'right',
  },
  {
    field: 'agentName',
    headerName: 'Agent',
    flex: 1,
    minWidth: 120,
  },
];

export default function PropertiesTable() {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    axios
      .get('https://t9hcok2ntd.execute-api.us-east-2.amazonaws.com/prod/getProperties')
      .then((res) => {
        // Add ID if missing
        const withIds = res.data.map((item, index) => ({
            id: item.propertyId || index,
            address: item.address,
            status: item.stat,
            price: `$ ${Number(item.price).toFixed(2)}`,
            daysOnMarket: item.list_date,
            agentName: item.list_agent,
        }));
        setRows(withIds);
      })
      .catch((err) => {
        console.error('Failed to fetch properties:', err);
      });
  }, []);

  return (
    <DataGrid
      rows={rows}
      columns={columns}
      checkboxSelection
      initialState={{
        pagination: { paginationModel: { pageSize: 10 } },
      }}
      pageSizeOptions={[10, 20, 50]}
      getRowClassName={(params) =>
        params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
      }
      density="compact"
    />
  );
}
